/* import __COLOCATED_TEMPLATE__ from './payout-settings.hbs'; */
import { computed } from '@ember/object';
import { filter, sort } from '@ember/object/computed';
import Component from '@ember/component';
import { PAYOUT_ACCOUNT } from '../../../models/payout-account';

const CLASS_NAME = 'SH-c-payout-settings';

const HYPERWALLET_RELEASE_DATE = new Date('Tue Jun 29 2021 19:00:00 GMT-0500 (Central Daylight Time)');

export default Component.extend({
  classNames: [CLASS_NAME],
  CLASS_NAME,

  /** @param {User|null} */
  user: null,

  /** @param {Boolean} */
  isLoading: false,

  /** @param {Boolean} */
  isRefreshing: false,

  /** @param {Boolean} */
  refreshFailed: false,

  /** @param {Function} */
  onCreate: () => {},

  /** @param {Function} */
  onRemove: () => {},

  /** @param {Function} */
  onSelect: () => {},

  /** @param {Function} */
  onRefresh: () => {},

  /** @param {Function} */
  onVerify: () => {},

  /** @type {Ember.A<PayoutAccount>} */
  filteredPayoutAccounts: filter(
    'user.payoutAccounts.@each.status',
    function (payoutAccount) {
      return payoutAccount.get('status') !== PAYOUT_ACCOUNT.STATUSES.UNLINKED;
    },
  ),

  /** @type {Array<String>} */
  payoutAccountsSortOrder: ['createdAt'],

  /** @param {Ember.A<PayoutAccount>} */
  payoutAccounts: sort('filteredPayoutAccounts', 'payoutAccountsSortOrder'),

  /** @type {Boolean} */
  _showNoSelectionWarning: computed('payoutAccounts.@each.{status,preferred}', function () {
    const payoutAccounts = this.get('payoutAccounts');

    if (!payoutAccounts.length) return false;

    const hasActivePayoutAccounts = payoutAccounts
      .some((payoutAccount) => payoutAccount.get('status') === PAYOUT_ACCOUNT.STATUSES.ACTIVE);

    if (!hasActivePayoutAccounts) return false;

    const hasPreferredPayoutAccount = payoutAccounts
      .some((payoutAccount) => payoutAccount.get('preferred'));

    if (hasPreferredPayoutAccount) return false;

    return true;
  }),

  /** @type {Boolean} */
  _showAnnouncement: computed('payoutAccounts.@each.createdAt', function () {
    const payoutAccounts = this.get('payoutAccounts');

    if (!payoutAccounts.length) return false;

    // Only show the announcement if there are no accounts created since the Hyperwallet release.
    return !payoutAccounts.some((account) => {
      return new Date(account.get('createdAt')).getTime() > HYPERWALLET_RELEASE_DATE.getTime();
    });
  }),

  actions: {
    handleCreate() {
      this.get('onCreate')();
    },

    handleRemove(payoutAccount) {
      this.get('onRemove')(payoutAccount);
    },

    handleSelect(payoutAccount) {
      this.get('onSelect')(payoutAccount);
    },

    handleRefresh() {
      this.get('onRefresh')();
    },

    handleVerify() {
      this.get('onVerify')();
    },
  },
});
